var React = require('react');

function LoupeLight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"transform":"scale(3)","d":"m7.0833 13.75c3.6823 0 6.6667-2.9844 6.6667-6.6667 0-3.681-2.9844-6.6667-6.6667-6.6667-3.6823 0-6.6667 2.9857-6.6667 6.6667 0 3.6823 2.9844 6.6667 6.6667 6.6667z","stroke":"#787676","key":0}),React.createElement("path",{"transform":"scale(3)","d":"m11.797 11.797 7.7865 7.7865","stroke":"#1a1a1a","key":1})]));
}

LoupeLight.defaultProps = {"version":"1.1","viewBox":"0 0 60 60"};

module.exports = LoupeLight;

LoupeLight.default = LoupeLight;
